"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var borderRadius_1 = require("../../utils/styled/borderRadius");
var Button_1 = require("../Common/Button");
var Icon_1 = require("../Common/Icon");
var ResultsContainer_1 = require("./ResultsContainer");
var SharedSearchComponents_1 = require("./SharedSearchComponents");
var smallSize = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: ", ";\n\twidth: ", ";\n\ti {\n\t\tfont-size: 13px !important;\n\t\twidth: 13px;\n\t\theight: 13px;\n\t}\n"], ["\n\theight: ", ";\n\twidth: ", ";\n\ti {\n\t\tfont-size: 13px !important;\n\t\twidth: 13px;\n\t\theight: 13px;\n\t}\n"])), globalVars_module_scss_1.default.heightSmall, globalVars_module_scss_1.default.heightSmall);
var mediumSize = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: ", ";\n\twidth: ", ";\n"], ["\n\theight: ", ";\n\twidth: ", ";\n"])), globalVars_module_scss_1.default.heightMedium, globalVars_module_scss_1.default.heightMedium);
var largeSize = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\theight: ", ";\n\twidth: ", ";\n\ti {\n\t\tfont-size: 17px !important;\n\t\twidth: 17px;\n\t\theight: 17px;\n\t}\n"], ["\n\theight: ", ";\n\twidth: ", ";\n\ti {\n\t\tfont-size: 17px !important;\n\t\twidth: 17px;\n\t\theight: 17px;\n\t}\n"])), globalVars_module_scss_1.default.heightLarge, globalVars_module_scss_1.default.heightLarge);
var Container = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 100%;\n"], ["\n\twidth: 100%;\n"])));
var SearchButton = (0, styled_components_1.default)(function (props) { return React.createElement(Button_1.Button, __assign({}, props)); })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t&.btn {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin: ", ";\n\t\tpadding: ", " !important;\n\t\tbackground: ", ";\n\t\tposition: absolute;\n\t\ttop: ", ";\n\t\tright: ", ";\n\t\t", "\n\t\t", "\n\t\ti {\n\t\t\tmargin-right: ", ";\n\t\t\tfont-size: 15px !important;\n\t\t\twidth: 15px;\n\t\t\theight: 15px;\n\t\t}\n\t\t", ";\n\t}\n\t&.btn:hover {\n\t\tbackground: #04667c;\n\t}\n\t&.btn:disabled {\n\t\tbackground-color: ", " !important;\n\t\ti {\n\t\t\tcolor: ", " !important;\n\t\t}\n\t}\n"], ["\n\t&.btn {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tmargin: ", ";\n\t\tpadding: ", " !important;\n\t\tbackground: ", ";\n\t\tposition: absolute;\n\t\ttop: ", ";\n\t\tright: ", ";\n\t\t", "\n\t\t", "\n\t\ti {\n\t\t\tmargin-right: ", ";\n\t\t\tfont-size: 15px !important;\n\t\t\twidth: 15px;\n\t\t\theight: 15px;\n\t\t}\n\t\t", ";\n\t}\n\t&.btn:hover {\n\t\tbackground: #04667c;\n\t}\n\t&.btn:disabled {\n\t\tbackground-color: ", " !important;\n\t\ti {\n\t\t\tcolor: ", " !important;\n\t\t}\n\t}\n"])), globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.mainBlue, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0, (0, borderRadius_1.borderLeftRadius)('0'), (0, borderRadius_1.borderRightRadius)('3px'), globalVars_module_scss_1.default.spacing0, function (props) { return (props.size === 'sm' ? smallSize : props.size === 'lg' ? largeSize : mediumSize); }, globalVars_module_scss_1.default.gray7, globalVars_module_scss_1.default.gray9);
SearchButton.displayName = 'SearchButton';
var SearchIcon = (0, styled_components_1.default)(Icon_1.Icon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tcolor: ", ";\n"], ["\n\tcolor: ", ";\n"])), globalVars_module_scss_1.default.white);
var SearchBox = /** @class */ (function (_super) {
    __extends(SearchBox, _super);
    function SearchBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasSearched: Boolean(_this.props.initialSearchText),
            searchText: _this.props.initialSearchText || '',
            placeHolder: _this.props.placeHolderText || 'Search Table',
        };
        _this.updateSearchText = _this.updateSearchText.bind(_this);
        _this.callCallback = _this.callCallback.bind(_this);
        _this.clearSearch = _this.clearSearch.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        return _this;
    }
    SearchBox.prototype.updateSearchText = function (evt) {
        var onSearchTextChange = this.props.onSearchTextChange;
        var searchText = evt.target.value;
        this.setState(__assign(__assign({}, this.state), { searchText: searchText }), function () {
            if (onSearchTextChange) {
                onSearchTextChange(searchText);
            }
        });
    };
    SearchBox.prototype.callCallback = function () {
        // searching on the empty or all whitespace string is treated like clearing the search.
        var isNullOrWhiteSpace = !this.state.searchText || !this.state.searchText.trim();
        if (isNullOrWhiteSpace) {
            this.setState(__assign(__assign({}, this.state), { searchText: '', hasSearched: false }));
            this.props.callbackFunc('');
        }
        else {
            this.setState(__assign(__assign({}, this.state), { hasSearched: true }));
            this.props.callbackFunc(this.state.searchText);
        }
    };
    SearchBox.prototype.clearSearch = function () {
        this.setState(__assign(__assign({}, this.state), { searchText: '', hasSearched: false }));
        this.props.callbackFunc('');
    };
    SearchBox.prototype.handleKeyPress = function (e) {
        if (e.key === 'Enter') {
            this.callCallback();
        }
    };
    SearchBox.prototype.render = function () {
        return (React.createElement(Container, { className: this.props.className + ' tws-searchbox-container' },
            React.createElement(SharedSearchComponents_1.InnerSearchContainer, { inputWidth: this.props.inputWidth },
                React.createElement(SharedSearchComponents_1.SearchInput, { type: 'text', placeholder: this.state.placeHolder, value: this.state.searchText, maxLength: 250, onKeyPress: this.handleKeyPress, onChange: this.updateSearchText, inputSize: this.props.inputSize, disabled: this.props.disabled }),
                React.createElement(ResultsContainer_1.ResultsContainer, { show: this.state.hasSearched, onClear: this.clearSearch, resultsCount: this.props.resultsCount, inputSize: this.props.inputSize }),
                React.createElement(SearchButton, { className: 'tws-searchbox-search-button', flat: true, onClick: this.callCallback, size: this.props.inputSize, disabled: this.props.disabled, tabIndex: -1 },
                    React.createElement(SearchIcon, { name: 'search' })))));
    };
    return SearchBox;
}(React.Component));
exports.default = SearchBox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
